import React from "react";
import styled from "@emotion/styled";

const StyledDiv = styled.div`
  /* border: 2px solid red; */

  /* bottom: 0;
  position: sticky; */
  margin-top: auto;
  .container {
    background-color: #333333;
    color: white;

    display: flex;
    margin: none;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2.4rem;
    min-height: 14rem;
  }

  .footer-title-container {
    /* border: 2px solid yellow; */
    margin-top: 1.2rem;

    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  .footer-text {
    /* border: 2px solid gray; */

    width: 100%;
    margin: none;
    padding: 0.8rem;
    box-sizing: border-box;
  }

  .footer-title {
    margin: 0;
    font-family: "Urbanist";
    font-size: 1.6rem;
  }

  .content {
    /* border: 2px solid brown; */

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    padding-top: 0.6rem;
    height: 100%;
    width: 24rem;
    box-sizing: border-box;
    /* width: 40%; */
  }

  @media (max-width: 576px) {
    /* Media query for screens 0 < X <= 576 */
    .container {
      /* border: 2px solid green; */
      flex-direction: column;
      min-width: 256px;
    }

    .content {
      width: 16rem;
    }
  }
`;

const Footer: React.FC = () => {
  return (
    <StyledDiv>
      <div className="container">
        <div className="content">
          <div className="footer-title-container">
            <h3 className="footer-title">Ana Health</h3>
          </div>
          <p className="footer-text">
            Somos um serviço de acesso à saúde,
            <br />
            com a missão de levar até você, acessibilidade e
            <br />
            acolhimento para promover mais qualidade de vida.
            <br />
            #breakthesystem
          </p>
        </div>
        <div className="content">
          <div className="footer-title-container">
            <h3 className="footer-title">Contato</h3>
          </div>
          <p className="footer-text">
            Av. Brg. Faria Lima 2369
            <br />
            andar 11, conj 1102
            <br />
            Jardim Paulistano
            <br />
            São Paulo - SP
          </p>
        </div>
      </div>
    </StyledDiv>
  );
};

export default Footer;
